import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const memphisConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Memphis FL Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Memphis, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_memphis_fl',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Memphis, FL',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Memphis FL Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the residential 
     and rural properties of <strong>Memphis, FL</strong>. This quiet Manatee County 
     community may be off the main roads, but the tree hazards here are very real
     large oaks and pines growing close to homes, overgrown canopies after a wet season, 
     and storm damage that leaves dangerous limbs hanging or trunks split near structures. 
     Our team travels out here and handles the job completely.`,

    `We specialize in <strong>hazardous tree removal and professional trimming</strong>
     including full tree takedowns, large limb removal near homes and outbuildings, 
     post storm cleanup and debris hauling, and canopy reduction on trees that have 
     outgrown their space. We bring the equipment and experience the job requires and 
     leave your property clean.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree care 
     throughout <strong>Memphis, FL</strong> and the surrounding <strong>Rural Manatee 
     County</strong> area making sure every property, no matter how remote, gets the 
     professional tree service it deserves.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Memphis, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_MemphisFL = () => <LocationPage config={memphisConfig} />;
export default Services_MemphisFL;
